import availableMessageTypes from '@/helpers/availableMessageTypesHelper'

export default function() {
    return {
        logs: [],
        fields: [
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'recipient',
                label: 'Destinatário'
            },
            {
                key: 'type',
                label: 'Tipo'
            },
            {
                key: 'template',
                label: 'Template'
            },
            {
                key: 'createdAt',
                label: 'Data do envio'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ],
        availableMessageTypes: [
            {
                label: 'Todos',
                code: null
            },
            ...availableMessageTypes
        ],
        itemsPerPage: 15,
        totalPages: 0,
        currentPage: 1,
        filters: {
            type: null
        },
        showLogDetails: false,
        logDetails: {}
    }
}
